import React, { Fragment, useState, useEffect, useRef } from "react";
import man from "assets/images/dashboard/profile.png";
import { LogIn, User, Minimize, MessageSquare, Bell } from "react-feather";
import {
  setTranslations,
  setDefaultLanguage,
  setLanguageCookie,
  setLanguage,
  translate,
} from "react-switch-lang";
import { useHistory } from "react-router-dom";
import { English, EricaHughes, KoriThomas, AinChavez } from "constant";
import en from "assets/i18n/en.json";
import ar from "assets/i18n/ar.json";
import { setLayoutLtr, setLayoutRtl } from "layout/theme-customizer";
import { POSITIONS } from "constant/variables";
import { getIsAdmin, getOutletRegion } from "utils";
import { logoutApi } from "service/signInService";
import toast from "react-hot-toast";
import api from "components/api/api";

setTranslations({ en, ar });
setDefaultLanguage("en");
setLanguageCookie();

const PROFILE_CLOSE_DELAY = 2000; // 2 seconds

const Rightbar = (props) => {
  const [unreadCount, setUnreadCount] = useState(0);
  const userId = localStorage.getItem("userId");
  const history = useHistory();
  const [langdropdown, setLangdropdown] = useState(false);
  const [selected, setSelected] = useState("en");
  const [chatDropDown, setChatDropDown] = useState(false);
  const [role, setRole] = useState("");
  const [outlet, setOutlet] = useState("");
  const [profileHover, setProfileHover] = useState(false); // NEW: controls the delayed "active" class
  const closeTimerRef = useRef(null); // NEW
  var OwnerPosition;
  var userName;
  const outletName = localStorage.getItem("Outlet");
  useEffect(() => {
    OwnerPosition = JSON.parse(localStorage.getItem("Position"));
    userName = localStorage.getItem("Name");
    dropDown();
  }, []);
  const dropDown = async () => {
    // console.log(userName, OwnerPosition);
    if (OwnerPosition === "A") {
      setRole("Promoter/CSR");
    } else if (OwnerPosition === "OM") {
      setRole("Outlet Manager");
    } else if (OwnerPosition === "M") {
      setRole("Manager");
    } else if (OwnerPosition === "SM") {
      setRole("Senior Manager");
    } else if (OwnerPosition === "GM") {
      setRole("General Manager");
    } else if (OwnerPosition === "VP") {
      setRole("Vice President");
    }
    setOutlet(outletName);
  };

  const handleSetLanguage = (key) => {
    setLanguage(key);
    setSelected(key);
    if (key === "ar") {
      setLayoutRtl();
    } else {
      setLayoutLtr();
    }
  };
  const Logout_From_Auth0 = () => {
    // localStorage.removeItem("clientId")
    // localStorage.removeItem("Name")
    // localStorage.removeItem("Position")
    logoutApi();
    setTimeout(() => {
      localStorage.clear();
      toast.success("Log out successful");
      history.push(`${process.env.PUBLIC_URL}/login`);
    }, 500);
  };

  const goToNotifications = () => {
    history.push(`${process.env.PUBLIC_URL}/notification-center`);
  };

  const fetchUnreadCount = React.useCallback(async () => {
    try {
      const res = await api.fetchUnreadNotificationCount(userId);
      setUnreadCount(Number(res?.data) || 0);
    } catch {
      setUnreadCount(0);
    }
  }, [userId]);

  useEffect(() => {
    if (!userId) return;
    fetchUnreadCount();

    const handleRefresh = () => {
      fetchUnreadCount();
    };

    window.addEventListener("notifications:refresh", handleRefresh);

    return () => {
      window.removeEventListener("notifications:refresh", handleRefresh);
    };
  }, [userId, fetchUnreadCount]);

  // NEW: hover handlers with a 2s grace period before closing
  const handleProfileMouseEnter = () => {
    if (closeTimerRef.current) {
      clearTimeout(closeTimerRef.current);
      closeTimerRef.current = null;
    }
    setProfileHover(true);
  };

  const handleProfileMouseLeave = () => {
    closeTimerRef.current = setTimeout(() => {
      setProfileHover(false);
    }, PROFILE_CLOSE_DELAY);
  };

  useEffect(() => {
    return () => {
      if (closeTimerRef.current) clearTimeout(closeTimerRef.current);
    };
  }, []);

  return (
    <Fragment>
      <div className="nav-right col-8 pull-right right-header p-0">
        <ul className="nav-menus">
          <li className="language-nav">
            <div
              className={`translate_wrapper ${langdropdown ? "active" : ""}`}
            ></div>
          </li>

          {!getIsAdmin() && (
            <li
              className="notification-nav"
              onClick={goToNotifications}
              style={{ position: "relative", cursor: "pointer" }}
            >
              <Bell color="#799dc0" size={18} />

              {unreadCount > 0 && (
                <span
                  className="notification-badge"
                  style={{
                    position: "absolute",
                    top: "-4px",
                    right: "-6px",
                    background: "red",
                    color: "white",
                    fontSize: "10px",
                    padding: "2px 5px",
                    borderRadius: "50%",
                    lineHeight: "1",
                    minWidth: "16px",
                    textAlign: "center",
                  }}
                >
                  {unreadCount > 99 ? "99+" : unreadCount}
                </span>
              )}
            </li>
          )}

          {/* Same structure as before — just added onMouseEnter/onMouseLeave and a "profile-hover" class */}
          <li
            className={`profile-nav onhover-dropdown p-0 ${
              profileHover ? "profile-hover" : ""
            }`}
            onMouseEnter={handleProfileMouseEnter}
            onMouseLeave={handleProfileMouseLeave}
          >
            <div className="media profile-media align-items-center">
              <img className="b-r-10" src={man} alt="" />
              <div className="media-body">
                <span>{userName}</span>
                <p className="mb-0 font-roboto">
                  {role} <i className="middle fa fa-angle-down"></i>
                </p>
                {getOutletRegion() ? (
                  <p className="mb-0 mt-2 font-roboto">{getOutletRegion()} </p>
                ) : null}
              </div>
            </div>
            <ul
              className={`profile-dropdown onhover-show-div ${
                profileHover ? "active" : ""
              }`}
            >
              <li>
                <User />
                <span>{props.t("Profile")} </span>
              </li>
              <li onClick={Logout_From_Auth0}>
                <LogIn />
                <span>{props.t("Logout")}</span>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </Fragment>
  );
};
export default translate(Rightbar);
